export const getNumeroInscricaoProcesso = (user, processoId) => {
    if (user == null) return '-';

    const inscricoes = Array.isArray(user.inscricoes) ? user.inscricoes : [];
    const inscricao = inscricoes.find((item) => {
        const itemProcessoId = item.processo_id || item.processo?.id;
        return String(itemProcessoId) === String(processoId);
    });

    return inscricao?.numero_inscricao || user.numero_inscricao || '-';
};

export const getNumerosInscricao = (user) => {
    if (user == null) return ['-'];

    const inscricoes = Array.isArray(user.inscricoes) ? user.inscricoes : [];
    const numeros = inscricoes
        .map((item) => item?.numero_inscricao)
        .filter((item) => item != null && item !== '');

    if (numeros.length > 0) {
        return [...new Set(numeros)];
    }

    return user.numero_inscricao ? [user.numero_inscricao] : ['-'];
};
